<template>
  <div>
    <FairUseCountdownBadge
      class="premiumBadge"
      :featureCode="featureCode"
      @click="handleLearnMoreClick"
    />
    <Card class="card">
      <template v-slot:header>
        <header
          class="cardHeader"
        >
          <HeadingSmall :hasMargin="false">
            {{ featureTitle }}
          </HeadingSmall>

          <LearnMoreLink
            :featureCode="featureCode"
            :featureName="featureTitle"
          />
        </header>
      </template>
      <template v-slot:body>
        <ParagraphBody
          class="description"
        >
          {{ featureDescription }}
        </ParagraphBody>
      </template>
    </Card>
  </div>
</template>

<script>
import {
  Card,
  HeadingSmall,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import FairUseCountdownBadge from 'client/components/Badges/FairUseCountdownBadge.vue';
import LearnMoreLink from 'client/settings/FeatureSettings/LearnMoreLink.vue';

const {
  description,
  location,
  section,
  text,
} = eventProperties;

export default {
  name: 'TrialFeatureCard',

  components: {
    Card,
    FairUseCountdownBadge,
    LearnMoreLink,
    HeadingSmall,
    ParagraphBody,
  },

  props: {
    featureCode: {
      type: String,
      required: true,
    },
    featureDescription: {
      type: String,
      required: true,
    },
    featureTitle: {
      type: String,
      required: true,
    },
  },

  methods: {
    handleLearnMoreClick() {
      EventHelper.triggerLinkClicked({
        [description]: `Learn More link clicked from ${this.featureTitle}`,
        [location]: 'Settings | Features',
        [section]: `Features You're Using | ${this.featureTitle}`,
        [text]: 'Learn More',
      });
    },
  },
};
</script>

<style scoped>
.card {
  --text-max-width: 75ch;
}

.card:not(:last-child) {
  margin-bottom: var(--jc-spacer);
}

.cardHeader {
  --switch-label-align: center;
  --switch-label-size: var(--jcBodyLarge);
  --switch-label-weight: 700;

  display: flex;
  flex-wrap: wrap;
  gap: var(--jc-spacer);
}

.description {
  max-width: var(--text-max-width);
}

.premiumBadge {
  width: 100%;
}
</style>
